import { render, staticRenderFns } from "./FixedAssets.vue?vue&type=template&id=50f17372"
import script from "./FixedAssets.vue?vue&type=script&lang=js"
export * from "./FixedAssets.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports